// src/components/AddChannelsCard.js

import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link as RouterLink } from 'react-router-dom';
import {
    Card,
    CardContent,
    CardActions,
    IconButton,
    Typography,
    Box,
    useTheme,
    Avatar,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { fetchAllAvailableChannels } from 'src/store/apps/channel';

const AddChannelsCard = () => {
    const dispatch = useDispatch();
    const theme = useTheme();

    // Fetch channels on component mount
    useEffect(() => {
        dispatch(fetchAllAvailableChannels({}));
    }, [dispatch]);

    // Get channels from Redux store
    const channels = useSelector((state) => state.channel.data);
    const channelCount = channels ? channels.length : 0;

    // Card styling
    const cardBackgroundColor = theme.palette.mode === 'dark' ? '#30334E' : '#FFFFFF';

    return (
        <Card
            elevation={4}
            sx={{
                position: 'relative',
                height: '100%',
                borderRadius: '12px',
                width: "auto",
                overflow: 'hidden',
                backgroundColor: cardBackgroundColor,
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                    transform: 'translateY(-10px)',
                    boxShadow: '0 10px 20px rgba(0, 0, 0, 0.15)',
                },
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
            }}
        >
            <CardContent sx={{ p: 3 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Avatar sx={{ mr: 0.5, backgroundColor: 'transparent', width: 56, height: 56 }}>
                        <AddIcon sx={{ color: 'text.primary' }} />
                    </Avatar>
                    <Typography variant="h5" sx={{ color: theme.palette.text.primary, fontWeight: 'bold' }}>
                        Add Channels
                    </Typography>
                </Box>
                <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                    Connect your social channels to manage your content seamlessly.
                </Typography>
                
            </CardContent>
            <CardActions sx={{ justifyContent: 'space-between', pt: "48px", }}>
               {/*<Box sx={{display: "flex", justifyContent: 'space-between'}}>*/}
                <Box sx={{ mt: 2, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Typography variant="body2" sx={{ color: theme.palette.text.primary }}>
                        {channelCount} Connected Channels
                    </Typography>
                </Box>
                <IconButton
                    component={RouterLink}
                    to="/pchannels"
                    sx={{ color: theme.palette.primary.main }}
                >
                    <ArrowForwardIcon />
                </IconButton>
                {/*</Box>*/}
            </CardActions>
        </Card>
    );
};

export default AddChannelsCard;
